module.exports = __webpack_public_path__ + "d65534944fdf61918a16dafe33592d80.png";